export { default } from './CanaisAtendimentoEmprestimos';
